import { Box, Divider, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ResetButton from '~/components/Buttons/ResetButton';
import { Slider } from '~/components/Slider';
import { ROIState } from '~/state/atoms/structureSet/roiAtoms';

const CONTOUR_THICKNESS_MIN_VALUE = 0.5;
const CONTOUR_THICKNESS_DEFAULT_VALUE = 1.0;
const CONTOUR_THICKNESS_MAX_VALUE = 2;
const CONTOUR_THICKNESS_STEP_VALUE = 0.01;

export default function StructureContourThicknessModifier({
    roi,
    onContourThicknessChange,
}: {
    roi: ROIState;
    onContourThicknessChange: (value: number) => void;
}) {
    const handleSliderChange = (newValue: number | number[]): void => {
        const validValue = validateValue(newValue as number);
        onContourThicknessChange(validValue);
    };

    const handleReset = () => {
        onContourThicknessChange(CONTOUR_THICKNESS_DEFAULT_VALUE);
    };

    const validateValue = (value: number): number => {
        return Math.min(
            Math.max(value, CONTOUR_THICKNESS_MIN_VALUE),
            CONTOUR_THICKNESS_MAX_VALUE
        );
    };

    return (
        <Slider
            label={
                <Box display="flex" alignItems="center">
                    <Typography fontSize={15}>
                        <FormattedMessage id="contourThickness" />
                    </Typography>
                    <Divider
                        flexItem
                        orientation="vertical"
                        sx={{ mx: 1, my: 1 }}
                    />
                    <ResetButton
                        onClick={handleReset}
                    />
                </Box>
            }
            value={roi.contourThickness}
            onChange={handleSliderChange}
            min={CONTOUR_THICKNESS_MIN_VALUE}
            max={CONTOUR_THICKNESS_MAX_VALUE}
            step={CONTOUR_THICKNESS_STEP_VALUE}
        />
    );
}
